import { IParallelepipedColor } from '../Parallelepiped/Parallelepiped.types'
import { BackgroundColorType } from '../../utils/constants'

export const parallelepipedColors: Record<BackgroundColorType, IParallelepipedColor> = {
  white: 'white',
  grey: 'grey',
  greyLight: 'greyLight',
  greyLighter: 'greyLighter',
  dark: 'black',
}
